/**
 * List of brands and corresponding data to show on /brands/{brandName}
 */
export default [
  { // the key that matches the URI
    brandId: 122,
    uri: 'shell',
    name: 'Shell', // the display name for the mini-hero banner
    imageUrl: 'https://images.gasbuddy.io/b/122.png',
  },
  {
    brandId: 38,
    uri: 'costco',
    name: 'Costco',
    imageUrl: 'https://images.gasbuddy.io/b/38.png',
  },
  {
    brandId: 23,
    uri: 'bp',
    name: 'BP',
    imageUrl: 'https://images.gasbuddy.io/b/23.png',
  },
  {
    brandId: 92,
    uri: 'mobil',
    name: 'Mobil',
    imageUrl: 'https://images.gasbuddy.io/b/92.png',
  },
  {
    brandId: 125,
    uri: 'speedway',
    name: 'Speedway',
    imageUrl: 'https://images.gasbuddy.io/b/125.png',
  },
  {
    brandId: 31,
    uri: 'chevron',
    name: 'Chevron',
    imageUrl: 'https://images.gasbuddy.io/b/31.png',
  },
  {
    brandId: 87,
    uri: 'marathon',
    name: 'Marathon',
    imageUrl: 'https://images.gasbuddy.io/b/87.png',
  },
  {
    brandId: 48,
    uri: 'exxon',
    name: 'Exxon',
    imageUrl: 'https://images.gasbuddy.io/b/48.png',
  },
  {
    brandId: 130,
    uri: 'sunoco',
    name: 'Sunoco',
    imageUrl: 'https://images.gasbuddy.io/b/130.png',
  },
  {
    brandId: 142,
    uri: 'valero',
    name: 'Valero',
    imageUrl: 'https://images.gasbuddy.io/b/142.png',
  },
  {
    brandId: 20,
    uri: 'arco',
    name: 'ARCO',
    imageUrl: 'https://images.gasbuddy.io/b/20.png',
  },
  {
    brandId: 118,
    uri: 'safeway',
    name: 'Safeway',
    imageUrl: 'https://images.gasbuddy.io/b/118.png',
  },
  {
    brandId: 61,
    uri: 'gulf',
    name: 'Gulf',
    imageUrl: 'https://images.gasbuddy.io/b/61.png',
  },
  {
    brandId: 33,
    uri: 'citgo',
    name: 'CITGO',
    imageUrl: 'https://images.gasbuddy.io/b/33.png',
  },
  {
    brandId: 32,
    uri: 'circle-k',
    name: 'Circle K',
    imageUrl: 'https://images.gasbuddy.io/b/32.png',
  },
  {
    brandId: 135,
    uri: 'texaco',
    name: 'Texaco',
    imageUrl: 'https://images.gasbuddy.io/b/135.png',
  },
  {
    brandId: 109,
    uri: 'racetrac',
    name: 'RaceTrac',
    imageUrl: 'https://images.gasbuddy.io/b/109.png',
  },
  {
    brandId: 36,
    uri: 'conoco',
    name: 'Conoco',
    imageUrl: 'https://images.gasbuddy.io/b/36.png',
  },
  {
    brandId: 136,
    uri: 'thorntons',
    name: 'Thorntons',
    imageUrl: 'https://images.gasbuddy.io/b/136.png',
  },
  {
    brandId: 101,
    uri: 'phillips-66',
    name: 'Phillips 66',
    imageUrl: 'https://images.gasbuddy.io/b/101.png',
  },
  {
    brandId: 28,
    uri: 'casey-s',
    name: 'Casey\'s',
    imageUrl: 'https://images.gasbuddy.io/b/28.png',
  },
  {
    brandId: 108,
    uri: 'quiktrip',
    name: 'QuikTrip',
    imageUrl: 'https://images.gasbuddy.io/b/108.png',
  },
  {
    brandId: 13,
    uri: 'esso',
    name: 'Esso',
    imageUrl: 'https://images.gasbuddy.io/b/13.png',
  },
  {
    brandId: 16,
    uri: 'aafes',
    name: 'AAFES',
    description: 'No Description',
    imageUrl: 'https://images.gasbuddy.io/b/16.png',
  },
  {
    brandId: 14,
    uri: '7-eleven',
    name: '7-Eleven',
    description: 'No Description',
    imageUrl: 'https://images.gasbuddy.io/b/14.png',
  },
  {
    brandId: 2005,
    uri: 'canco',
    name: 'Canco',
    imageUrl: 'https://images.gasbuddy.io/b/2005.png',
  },
];
